import {Component, OnInit, ViewChild} from '@angular/core';
import {PosNavbarComponent} from "./navbar/posNavbar.component";
import {AlertService, UserService} from "../services";
import {Observable, of} from "rxjs";
import {locale as polish} from "./i18n/pl";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {OrderService} from "../services/order.service";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Supplier} from "../models/supplier";
import {Product} from "../models/product";
import {Unit} from "../models/unit";
import {VatRate} from "../models/vatRate";
import {User} from "../models";
import {VoucherTemplate} from "../models/voucherTemplate";
import {Country} from "../models/country";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute, Router} from "@angular/router";
import {SupplierService} from "../services/supplier.service";
import {SupplierOrderService} from "../services/supplierOrder.service";
import {ProductService} from "../services/product.service";
import {UnitService} from "../services/unit.services";
import {VatRateService} from "../services/vatRate.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {VoucherTemplateService} from "../services/voucherTemplate.service";
import {CountryService} from "../services/country.service";
import {catchError, debounceTime, first, map, startWith, switchMap} from "rxjs/operators";
import {Items} from "../models/items";
import {Order} from "../models/order";
import {AddProductEmitterService} from "./service/add-product-emitter.service";
import {AddVoucherEmitterService} from "./service/add-voucher-emitter.service";
import {AdditionalProductInfoDialogComponent} from "./dialog/additionalProductInfoDialog.component";
import {AdditionalVoucherInfoDialogComponent} from "./dialog/additionalVoucherInfoDialog.component";
import {CashReport} from "../cashReport/model/cashReport";
import {DiscountService} from "../discount/service/discount.service";
import {VirtualReceiptService} from "./service/virtualReceipt.servicee";
import {VirtualReceipt} from "./model/virtualReceipt";
import {ResourceService} from "../services/resource.service";
import {Resource} from "../models/resource";
import {FiscalPrinterInactiveDialogComponent} from "./dialog/fiscalPrinterInactiveDialog/fiscalPrinterInactiveDialog.component";

@Component({
    templateUrl: './pos.component.html',
    styleUrls: ['./pos.component.scss']
})
export class PosComponent implements OnInit {
    @ViewChild('posNavbar', { static: false }) posNavbar: PosNavbarComponent;

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    type: string;
    productId: string;
    isAddMode: boolean;
    suppliers: Supplier[];
    dialogRef: any;
    products: Product[];
    units: Unit[];
    vatRates: VatRate[];
    customers: User[];
    workers: User[];
    voucherTemplates: VoucherTemplate[] = [];
    enabledVoucherSale: boolean;
    countries: Country[];
    paymentMethods: string[] = ['gotówka', 'karta'];
    filteredOptions: Observable<User[]>;
    order: Order = new Order();
    productInformationsDialogRef: any;
    voucherInformationsDialogRef: any;
    activeCashReport: CashReport|null;
    customer: User|null;
    virtualReceipt: VirtualReceipt|null;
    fiscalPrinter: Resource|null;

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private supplierService: SupplierService,
        private supplierOrderService: SupplierOrderService,
        private productService: ProductService,
        private unitService: UnitService,
        private vatRateService: VatRateService,
        private _matSnackBar: MatSnackBar,
        private orderService: OrderService,
        private userService: UserService,
        private voucherTemplateService: VoucherTemplateService,
        private countryService: CountryService,
        private addProductEmitterService: AddProductEmitterService,
        private addVoucherEmitterService: AddVoucherEmitterService,
        private discountService: DiscountService,
        private virtualReceiptService: VirtualReceiptService,
        private resourceService: ResourceService,
    ) {
        this.translationLoader.loadTranslations(polish);

        this.activeCashReport = this.route.snapshot.data.activeCashReport;
        this.customer = this.route.snapshot.data.customer;

        if (!this.activeCashReport) {
            router.navigateByUrl('/cash-reports');
        }

        componentTitleService.clearTitle();
        componentTitleService.addPart('Point of sale');

        if (this.customer) {
            componentTitleService.addPart('Open bill');
            let name = this.customer.firstName + " " + this.customer.lastName;

            if (this.customer.phone && this.customer.phone.length > 0) {
                name = name + ", " + this.customer.phone;
            }

            if (this.customer.email && this.customer.email.length > 0) {
                name = name + ", " + this.customer.email;
            }

            componentTitleService.addPart(name);
        }

        this.countryService.getAll().subscribe((res: any[]) => {
            this.countries = res;
        }, error => {
            this.alertService.error(error);
        })
    }

    ngOnInit() {
        this.resourceService.getFiscalPrinters().subscribe((printers: Resource[]) => {
            if (printers.length>0) {
                this.fiscalPrinter = printers[0];
                let currentDate = new Date();
                let printerActivityDate = new Date(this.fiscalPrinter.lastActivity);
                let seconds = Math.abs(printerActivityDate.getTime() - currentDate.getTime())/1000;

                if (seconds > 30) {
                    this.dialogRef = this._matDialog.open(FiscalPrinterInactiveDialogComponent, {
                        panelClass: 'fiscal-printer-inactive-dialog',
                        data: {
                            action: 'new',
                        },
                        width: '500px',
                    });

                    this.dialogRef.disableClose = true;
                    this.dialogRef.backdropClick().subscribe(_ => {
                        // this.confirm();
                    });

                    this.dialogRef.afterClosed()
                        .subscribe((response: FormGroup) => {

                        });
                }
            }
        }, error => {
            console.log(error);
        });

        if (this.customer) {
            this.virtualReceiptService.getByCustomer(this.customer.id).subscribe((res: VirtualReceipt)=> {
                this.virtualReceipt = res;
                this.order.virtualReceipt = this.virtualReceipt.id;
                this.order.discounts = [];
                for (let i=0; i<res.items.length; i++) {
                    for (let j=0; j<res.items[i].quantity; j++) {
                        if (res.items[i].product) {
                            this.order.addProduct(res.items[i].product);
                        } else {
                            this.order.addVoucher(res.items[i].voucher);
                        }
                    }
                }
            }, error => {
                console.log(error);
            });
        }

        this.enabledVoucherSale = false;
        this.productId = this.route.snapshot.params['productId'];
        this.type = this.route.snapshot.params['type'];

        this.isAddMode = true;

        this.form = this.formBuilder.group({
            customer: [''],
            description: [''],
            worker: ['', Validators.required],
            paymentMethod: ['', Validators.required],
            documentDate: [''],
            invoice: [''],
            nip: [''],
            companyName: [''],
            companyStreet: [''],
            companyPostCode: [''],
            companyCity: [''],
            companyCountry: [''],
            items: this.formBuilder.array([]),
            vouchers: this.formBuilder.array([]),
        });

        if (!this.isAddMode) {

        } else {
            this.addProductLine();
        }

        this.voucherTemplateService.getAllForPos().pipe(first()).subscribe((res: VoucherTemplate[]) => {
                let templates = [];
                res.forEach(function(template: VoucherTemplate) {
                    if (!template.nameForReceipt || !template.services || template.services.length === 0 || template.nameForReceipt.length === 0 || !template.salePrice || !template.vatRate) {
                        return;
                    }

                    if (template.multiSport || template.pzuSport || template.medicover || template.profit) {
                        return;
                    }

                    templates.push(template);
                });

                this.voucherTemplates = templates;

                // Load voucher groups immediately after templates are loaded
                this.loadVoucherGroupsFromTemplates();
            },
            error => {
                this.alertService.error(error);
            });

        this.userService.getAllWorkers().pipe(first()).subscribe((res: Items) => {
                this.workers = res.items;
            },
            error => {
                this.alertService.error(error);
            });

        this.productService.getAll().subscribe((res: Product[]) => {

            let products = [];
            res.forEach(function(product: Product) {
                if (product.nameForReceipt.length === 0 || !product.priceGross || !product.vatRate || !product.unit) {
                    return;
                }
                products.push(product);
            });

            this.products = products;

            if (this.type === 'product' && this.productId) {
                for (let i = 0; i < this.products.length; i++) {
                    if (this.products[i].id != this.productId) {
                        continue;
                    }

                    this.items().at(0).get('product').setValue(this.productId);

                    if (typeof this.products[i].unit !== "undefined" && this.products[i].unit.id !== null) {
                        this.items().at(0).get('unit').setValue(this.products[i].unit.id);
                    }

                    if (typeof this.products[i].vatRate !== "undefined" && this.products[i].vatRate != null) {
                        this.items().at(0).get('vatRate').setValue(this.products[i].vatRate.vatValue);
                    }

                    if (typeof this.products[i].purchasePriceGross !== "undefined" && this.products[i].priceGross != null) {
                        this.items().at(0).get('priceGross').setValue(this.products[i].priceGross);
                    }

                    if (!this.items().at(0).get('quantity').value) {
                        this.items().at(0).get('quantity').setValue(1);
                    }

                    break;
                }
            }
        }, error => {
            this.alertService.error(error);
        });

        this.vatRateService.getAll().subscribe((res: VatRate[]) => {
            this.vatRates = res;
        }, error => {
            this.alertService.error(error);
        });

        this.unitService.getAll().subscribe((res: Unit[]) => {
            this.units = res;
        }, error => {
            this.alertService.error(error);
        });

        if (!this.customer) {
            this.userService.getAllCustomers().subscribe((res: Items) => {
                this.customers = res.items;
                this.filteredOptions = this.form.get('customer').valueChanges
                    .pipe(
                        startWith(''),
                        debounceTime(300),
                        switchMap(value => {
                            if (value !== '') {
                                return this.lookup(value);
                            } else {
                                return of(null);
                            }
                        })
                    );
            }, error => {

            });
        } else {
            this.customers = [this.customer];
            this.order.customer = this.customer;
        }
    }

    calculateDiscounts() {
        this.discountService.recalculate(this.order).pipe(first())
            .subscribe(
                (data: Order) => {
                    this.order.priceGross = data.priceGross;
                    this.order.priceGrossBeforeDiscount = data.priceGrossBeforeDiscount;
                    this.order.discountValue = data.discountValue;
                    this.order.items = data.items;
                    this.order.vouchers = data.vouchers;
                    this.order.discounts = data.discounts;
                }
            );
    }

    lookup(value: string): Observable<Items> {
        return this.userService.getAllCustomersBy(value).pipe(
            // map the item property of the github results as our return object
            map(results => results.items),
            // catch errors
            catchError(_ => {
                return of(null);
            })
        );
    }

    displayFn(userId: User): string {
        return (userId)? userId.firstName + ' ' + userId.lastName + '; ' + userId.phone: '';
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        // this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createOrder();
        } else {
            this.updateOrder();
        }
    }

    newProductLine(): FormGroup {
        return this.formBuilder.group({
            id: [''],
            product: ['', Validators.required],
            unit: ['', Validators.required],
            quantity: ['', Validators.required],
            vatRate: ['', Validators.required],
            // priceNet: ['', Validators.required],
            priceGross: ['', Validators.required],
        });
    }

    public addProductLine() {
        this.items().push(this.newProductLine());
    }

    public removeProductLine(lineIdx: number) {
        this.items().removeAt(lineIdx);
    }

    public items(): FormArray {
        return this.form.get('items') as FormArray;
    }

    newVoucherLine(): FormGroup {
        return this.formBuilder.group({
            id: [''],
            voucherTemplate: ['', Validators.required],
            quantity: ['', Validators.required],
            vatRate: ['', Validators.required],
            // priceNet: ['', Validators.required],
            priceGross: ['', Validators.required],
            description: [''],
            dedication: [''],
            owner: [''],
        });
    }

    public addVoucherLine() {
        this.vouchers().push(this.newVoucherLine());
    }

    public removeVoucherLine(lineIdx: number) {
        this.vouchers().removeAt(lineIdx);
    }

    public vouchers(): FormArray {
        return this.form.get('vouchers') as FormArray;
    }

    public enableVoucherSale() {
        this.enabledVoucherSale = true;
    }

    public onProductSelect(lineIdx: number, event: any) {
        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].id != event.value) {
                continue;
            }

            if (typeof this.products[i].unit !== "undefined" && this.products[i].unit.id !== null) {
                this.items().at(lineIdx).get('unit').setValue(this.products[i].unit.id);
            }

            if (typeof this.products[i].vatRate !== "undefined" && this.products[i].vatRate != null) {
                this.items().at(lineIdx).get('vatRate').setValue(this.products[i].vatRate.vatValue);
            }

            // if (typeof this.products[i].purchasePriceNet !== "undefined" && this.products[i].priceNet != null) {
            //     this.items().at(lineIdx).get('priceNet').setValue(this.products[i].priceNet);
            // }

            if (typeof this.products[i].priceGross !== "undefined" && this.products[i].priceGross != null) {
                this.items().at(lineIdx).get('priceGross').setValue(this.products[i].priceGross);
            }

            if (!this.items().at(lineIdx).get('quantity').value) {
                this.items().at(lineIdx).get('quantity').setValue(1);
            }

            break;
        }
    }

    public onVoucherSelect(lineIdx: number, event: any) {
        for (let i = 0; i < this.voucherTemplates.length; i++) {
            if (this.voucherTemplates[i].id != event.value) {
                continue;
            }

            if (typeof this.voucherTemplates[i].salePrice !== "undefined" && this.voucherTemplates[i].salePrice != null) {
                this.vouchers().at(lineIdx).get('priceGross').setValue(this.voucherTemplates[i].salePrice);
            }

            if (typeof this.voucherTemplates[i].vatRate !== "undefined" && this.voucherTemplates[i].vatRate != null) {
                this.vouchers().at(lineIdx).get('vatRate').setValue(this.voucherTemplates[i].vatRate.vatValue);
            }

            this.vouchers().at(lineIdx).get('quantity').setValue(1);

            break;
        }
    }

    public selectCustomer(event) {
        console.log(event);
    }

    public wantInvoice(event) {
        if (!event.checked) {
            this.f.nip.setValue("");
            this.f.companyName.setValue("");
            this.f.companyStreet.setValue("");
            this.f.companyPostCode.setValue("");
            this.f.companyCity.setValue("");
            this.f.companyCountry.setValue("");
        } else {
            let customerId = this.f.customer.value;

            for (let i = 0; i < this.customers.length; i++) {
                if (this.customers[i].id !== customerId) {
                    continue;
                }

                this.f.nip.setValue(this.customers[i].nip);
                this.f.companyName.setValue(this.customers[i].companyName);
                this.f.companyStreet.setValue(this.customers[i].companyStreet);
                this.f.companyPostCode.setValue(this.customers[i].companyPostCode);
                this.f.companyCity.setValue(this.customers[i].companyCity);
                this.f.companyCountry.setValue(this.customers[i].companyCountry);
            }
        }
    }

    public calculateLineValue(i: number) {
        return this.items().at(i).get('quantity').value * this.items().at(i).get('priceGross').value;
    }

    public calculateVoucherLineValue(i: number) {
        return this.vouchers().at(i).get('quantity').value * this.vouchers().at(i).get('priceGross').value;
    }

    private createOrder() {
        let order = this.form.value;

        if (!order.invoice) {
            order.nip = "";
            order.companyName = "";
            order.companyStreet = "";
            order.companyPostCode = "";
            order.companyCity = "";
            order.companyCountry = "";
        }

        if (order.customer !== null && typeof order.customer !== "undefined") {
            order.customer = order.customer.id;
        }

        if (order.items.length === 0 && order.vouchers.length === 0) {
            this.loading = false;
            this._matSnackBar.open('Order creation error - Positions are required', 'OK', {
                verticalPosition: 'top',
                duration: 5000,
                panelClass: ['snackbar-error']
            });

            return;
        }

        if (order.vouchers.length > 0 && (order.customer === null || typeof order.customer === "undefined")) {
            this.loading = false;
            this._matSnackBar.open('Order creation error - Customer is required', 'OK', {
                verticalPosition: 'top',
                duration: 5000,
                panelClass: ['snackbar-error']
            });

            return;
        }

        this.orderService.create(order)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Order added successfully');
                    this.router.navigate(['.', {relativeTo: this.route}]);

                    this._matSnackBar.open('Order created successfully', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                },
                error => {
                    this.loading = false;
                    this._matSnackBar.open('Order creation error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration: 5000,
                        panelClass: ['snackbar-error']
                    });
                });
    }

    private updateOrder() {
        this.orderService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful');
                    this.router.navigate(['..', {relativeTo: this.route}]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    addProduct(product: Product): void {
        this.addProductEmitterService.onAddProduct(product);
    }

    addVoucher(voucherTemplate: VoucherTemplate): void {
        this.addVoucherEmitterService.onAddVoucher(voucherTemplate);
    }

    showAdditionalProductInformationsDialog(product: Product) {
        this.productInformationsDialogRef = this._matDialog.open(AdditionalProductInfoDialogComponent, {
            panelClass: 'additional-product-info-dialog',
            data      : {
                action : 'show',
                product: product,
            },
            width: '350px',
        });

        this.productInformationsDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.addProduct(product);

                this.productInformationsDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    showAdditionalVoucherInformationsDialog(voucher: VoucherTemplate) {
        this.voucherInformationsDialogRef = this._matDialog.open(AdditionalVoucherInfoDialogComponent, {
            panelClass: 'additional-voucher-info-dialog',
            data      : {
                action : 'show',
                voucher: voucher,
            },
            width: '350px',
        });

        this.voucherInformationsDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.addVoucher(voucher);

                this.voucherInformationsDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    displayVouchers: boolean = true;
    displayProducts: boolean = true;
    productCategory: string;
    selectedVoucherGroupId: string | null = null;

    filterPostItems(id: string) {
        if (id === 'all') {
            this.displayProducts = true;
            this.displayVouchers = true;
        } else if (id === 'vouchers') {
            this.displayProducts = false;
            this.displayVouchers = true;
        } else if (id === 'products') {
            this.displayProducts = true;
            this.displayVouchers = false;
        }
        // Reset voucher group filter when changing main filter
        this.selectedVoucherGroupId = null;
    }

    filterPostItemsByCategory(id: string) {
        this.productCategory = id;
    }

    filterPostItemsByVoucherGroup(groupId: string | null) {
        this.selectedVoucherGroupId = groupId;
    }

    getFilteredVoucherTemplates(): VoucherTemplate[] {
        if (!this.selectedVoucherGroupId) {
            return this.voucherTemplates;
        }

        return this.voucherTemplates.filter(voucher =>
            voucher.group && voucher.group.id === this.selectedVoucherGroupId
        );
    }

    loadVoucherGroupsFromTemplates(): void {
        if (this.posNavbar && this.voucherTemplates) {
            this.posNavbar.updateVoucherGroups(this.voucherTemplates);
        }
    }
}
